module.exports = __webpack_public_path__ + "static/media/screenshot2.628be25c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Trip/screenshot2.jpeg
// module id = 288
// module chunks = 0